import { CheckCircle2, XCircle, AlertCircle } from "lucide-react";
import { usePT } from "@/lib/pt";

export const Eligibility = ({ e, onlyBlockers }) => {
  const { pt } = usePT();
  if (!e) return null;
  const bad = e.checks.filter((c) => !c.ok || c.warn);
  const shown = onlyBlockers ? e.checks.filter((c) => !c.ok) : e.checks;
  if (e.ready && !bad.length) return <p className="flex items-center gap-2 rounded-2xl bg-[#E3F4EA] p-3 text-sm font-semibold text-[#1F7A50]" data-testid="partner-eligibility-ready"><CheckCircle2 className="h-5 w-5" />{pt("You're all set to receive pickup requests.")}</p>;
  return (
    <div className={`space-y-1.5 rounded-2xl p-3 ${e.ready ? "bg-[#FFF8E6]" : "border-2 border-[#E05C3A] bg-[#FDF1EC]"}`} data-testid="partner-eligibility">
      <p className="text-base font-bold text-[#0D3B2B]">{pt(e.ready ? "You're receiving requests" : "Why you're not receiving requests")}</p>
      {shown.map((c) => (
        <p key={c.key} className="flex items-start gap-2 text-sm" data-testid={`elig-${c.key}`}>
          {c.warn ? <AlertCircle className="h-5 w-5 shrink-0 text-[#E0A43A]" /> : c.ok ? <CheckCircle2 className="h-5 w-5 shrink-0 text-[#2E9E6B]" /> : <XCircle className="h-5 w-5 shrink-0 text-[#E05C3A]" />}
          <span className={c.ok ? "text-[#4A6358]" : "font-semibold text-[#B4401F]"}>{pt(c.label)}</span>
        </p>
      ))}
    </div>
  );
};
